/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Outcome_Not_ConfiguredInputs */

const cs_lustrace_outcome_not_configured = /** @type {(inputs: Lustrace_Outcome_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenastaveno`)
};

const en_lustrace_outcome_not_configured = /** @type {(inputs: Lustrace_Outcome_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not configured`)
};

/**
* | output |
* | --- |
* | "Not configured" |
*
* @param {Lustrace_Outcome_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_outcome_not_configured = /** @type {((inputs?: Lustrace_Outcome_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Outcome_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_outcome_not_configured(inputs)
	return cs_lustrace_outcome_not_configured(inputs)
});